/* ============================================================
   sc-product-gallery.js — adds counter, dots, arrows, and a
   full-screen swipeable lightbox on top of Dawn's media gallery.
   Load with defer on product templates (see README).
   ============================================================ */
(function () {
  function init() {
    var list = document.querySelector('.product__media-list');
    if (!list || list.dataset.scGallery) return;
    list.dataset.scGallery = '1';

    var items = [].slice.call(list.querySelectorAll('.product__media-item'));
    if (items.length < 2) return;

    // Create our own tight-fitting positioning wrapper around just the
    // scrolling list, rather than guessing at Dawn's surrounding markup
    // (which differs between mobile and desktop layouts). This is what
    // guarantees the arrows/counter/zoom sit correctly ON the image on
    // both viewports, not off to the side or above/below it.
    var wrapper = document.createElement('div');
    wrapper.style.position = 'relative';
    list.parentNode.insertBefore(wrapper, list);
    wrapper.appendChild(list);

    // ---------- counter ----------
    var count = document.createElement('span');
    count.className = 'sc-gal-count';
    count.textContent = '1/' + items.length;
    wrapper.appendChild(count);

    // ---------- zoom button ----------
    var zoom = document.createElement('button');
    zoom.className = 'sc-gal-zoom';
    zoom.type = 'button';
    zoom.setAttribute('aria-label', 'Zoom image');
    zoom.textContent = '\u2922';
    wrapper.appendChild(zoom);

    // ---------- arrows ----------
    var prev = document.createElement('button');
    prev.className = 'sc-gal-arrow sc-gal-arrow--prev';
    prev.type = 'button'; prev.setAttribute('aria-label', 'Previous image');
    prev.textContent = '\u2039';
    var next = document.createElement('button');
    next.className = 'sc-gal-arrow sc-gal-arrow--next';
    next.type = 'button'; next.setAttribute('aria-label', 'Next image');
    next.textContent = '\u203A';
    wrapper.appendChild(prev); wrapper.appendChild(next);

    // ---------- dots (mobile) ----------
    var dots = document.createElement('div');
    dots.className = 'sc-gal-dots';
    items.forEach(function (_, i) {
      var d = document.createElement('i');
      if (i === 0) d.classList.add('on');
      dots.appendChild(d);
    });
    wrapper.appendChild(dots);

    var cur = 0;
    // Thumbnails are confirmed to correctly move the main image, so
    // arrows now also proxy-click the matching thumbnail — triggering
    // the exact same action a manual thumbnail click would, rather
    // than trying to replicate whatever internal mechanism handles
    // that ourselves. Purely additive: scrollTo below is untouched,
    // so mobile's already-working behavior can't be affected.
    var thumbButtons = [].slice.call(document.querySelectorAll('.thumbnail-list button, .thumbnail-list .thumbnail'));

    function goTo(i) {
      if (i < 0) i = items.length - 1;
      if (i >= items.length) i = 0;
      cur = i;
      list.scrollTo({ left: i * list.clientWidth, behavior: 'smooth' });
      if (thumbButtons[i]) thumbButtons[i].click();
      count.textContent = (i + 1) + '/' + items.length;
      [].forEach.call(dots.children, function (d, j) { d.classList.toggle('on', j === i); });
    }
    prev.addEventListener('click', function () { goTo(cur - 1); });
    next.addEventListener('click', function () { goTo(cur + 1); });

    var raf;
    list.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        cur = Math.round(list.scrollLeft / list.clientWidth);
        count.textContent = (cur + 1) + '/' + items.length;
        [].forEach.call(dots.children, function (d, j) { d.classList.toggle('on', j === cur); });
      });
    }, { passive: true });

    // ---------- lightbox ----------
    // currentSrc resolves differently per viewport/DPR and can pick a
    // smaller or context-specific variant — read srcset directly and
    // take the largest candidate instead, so the full image is always
    // what gets shown, regardless of which viewport opened it.
    function bestSrc(img) {
      var srcset = img.getAttribute('srcset');
      if (srcset) {
        var candidates = srcset.split(',').map(function (s) {
          var parts = s.trim().split(/\s+/);
          return { url: parts[0], w: parseInt(parts[1]) || 0 };
        }).sort(function (a, b) { return b.w - a.w; });
        if (candidates[0] && candidates[0].url) return candidates[0].url;
      }
      return img.currentSrc || img.src;
    }
    function upsizeUrl(url) {
      if (/[?&]width=\d+/.test(url)) {
        return url.replace(/([?&])width=\d+/, '$1width=1800');
      }
      return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=1800';
    }
    var lb, lbTrack, lbCount, lbCur = 0, built = false;
    function buildLb() {
      lb = document.createElement('div');
      lb.className = 'sc-lb';
      lb.setAttribute('role', 'dialog');
      lb.setAttribute('aria-label', 'Image zoom');
      lb.innerHTML =
        '<div class="sc-lb__top"><span class="sc-lb__count">1/' + items.length + '</span>' +
        '<button class="sc-lb__close" type="button" aria-label="Close zoom">\u00D7</button></div>' +
        '<div class="sc-lb__track"></div>' +
        '<button class="sc-lb__arrow sc-lb__arrow--prev" type="button" aria-label="Previous image">\u2039</button>' +
        '<button class="sc-lb__arrow sc-lb__arrow--next" type="button" aria-label="Next image">\u203A</button>';
      document.body.appendChild(lb);
      lbTrack = lb.querySelector('.sc-lb__track');
      lbCount = lb.querySelector('.sc-lb__count');

      items.forEach(function (item) {
        var img = item.querySelector('img');
        if (!img) return;
        var d = document.createElement('div');
        var large = document.createElement('img');
        large.src = upsizeUrl(bestSrc(img));
        large.alt = img.alt || '';
        large.loading = 'lazy';
        d.appendChild(large);
        lbTrack.appendChild(d);
      });

      lb.querySelector('.sc-lb__close').addEventListener('click', closeLb);
      lb.querySelector('.sc-lb__arrow--prev').addEventListener('click', function () { lbGo(lbCur - 1); });
      lb.querySelector('.sc-lb__arrow--next').addEventListener('click', function () { lbGo(lbCur + 1); });
      lbTrack.addEventListener('scroll', function () {
        var i = Math.round(lbTrack.scrollLeft / lbTrack.clientWidth);
        if (i !== lbCur) { lbCur = i; lbCount.textContent = (i + 1) + '/' + items.length; }
      }, { passive: true });
      document.addEventListener('keydown', function (e) {
        if (!lb.classList.contains('open')) return;
        if (e.key === 'Escape') closeLb();
        if (e.key === 'ArrowLeft') lbGo(lbCur - 1);
        if (e.key === 'ArrowRight') lbGo(lbCur + 1);
      });
      built = true;
    }
    function lbGo(i) {
      if (i < 0) i = items.length - 1;
      if (i >= items.length) i = 0;
      lbTrack.scrollTo({ left: i * lbTrack.clientWidth, behavior: 'smooth' });
    }
    function openLb(i) {
      if (!built) buildLb();
      lb.classList.add('open');
      document.body.style.overflow = 'hidden';
      requestAnimationFrame(function () {
        lbTrack.scrollTo({ left: i * lbTrack.clientWidth });
        lbCur = i; lbCount.textContent = (i + 1) + '/' + items.length;
      });
    }
    function closeLb() {
      lb.classList.remove('open');
      document.body.style.overflow = '';
      goTo(lbCur);
    }
    zoom.addEventListener('click', function () { openLb(cur); });
    items.forEach(function (item, i) {
      // Extra insurance against Dawn's own zoom/navigation firing on
      // this same click — remove any link target so there's nothing
      // for a competing handler to act on even if one exists.
      var wrapLink = item.querySelector('a');
      if (wrapLink) wrapLink.removeAttribute('href');

      item.addEventListener('click', function (e) {
        // don't hijack video/model media, only images
        if (item.querySelector('img') && !item.querySelector('video, model-viewer, iframe')) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          openLb(i);
        }
      }, true); // capture phase — runs before Dawn's own zoom listener, if any
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else init();
  // re-init after section reloads in the theme editor
  document.addEventListener('shopify:section:load', init);
})();
